import { Controller } from '@hotwired/stimulus';
import Vue from 'vue';

export default class extends Controller {
  static targets = ['template'];

  connect() {
    const el = this.templateTarget;

    this.vm = new Vue({
      el,
      data: {
        fields: [],
        // 静的ループ側 (質問を追加で増やしていない、既存/復元された質問) の件数。
        // mount 直後に実 DOM の件数から算出する (下記参照)。
        staticItemsCount: 0,
      },
      created: function () {
        this.toggle_incentive_options();
      },
      methods: {
        addInputField: function (e) {
          e.preventDefault();
          this.fields.push({ field: this.fields.length });
        },
        removeInputField: function (index) {
          if (this.staticItemsCount + this.fields.length <= 1) {
            alertify.error('質問は１つ以上必要です');
          } else {
            this.fields.splice(index, 1);
          }
        },
        toggle_item_options: (e) => {
          const selected_value = $(e.target).context.value;

          if (selected_value.match(/text/)) {
            $(e.target)
              .closest('.p-formA__item')
              .next('.item_options_field')
              .removeClass('active');
          } else if (selected_value.match(/picture/)) {
            $(e.target)
              .closest('.p-formA__item')
              .next('.item_options_field')
              .removeClass('active');
          } else if (
            selected_value.match(/star/) ||
            selected_value.match(/date/)
          ) {
            $(e.target)
              .closest('.p-formA__item')
              .next('.item_options_field')
              .removeClass('active');
          } else {
            $(e.target)
              .closest('.p-formA__item')
              .next('.item_options_field')
              .addClass('active');
          }

          if (selected_value.match(/text/)) {
            $(e.target)
              .closest('.p-formA__item')
              .nextAll('.text_area_option')
              .addClass('active');
          } else {
            $(e.target)
              .closest('.p-formA__item')
              .nextAll('.text_area_option')
              .removeClass('active');
          }
        },
        toggle_incentive_options: () => {
          const selected_value = $('#shop_campaign_incentive').val();
          switch (selected_value) {
            case 'stamp':
              $('.shop_barcode_select').addClass('active');
              break;
            default:
              $('.shop_barcode_select').removeClass('active');
              break;
          }
        },
        activ_destroy_flag_for_edit: (e) => {
          e.preventDefault();
          // NOTE: 削除ボタン内のアイコンをクリックした場合 e.target がアイコン
          // 要素になり data-item-id を取得できないため、リスナーがバインドされて
          // いるボタン自身を指す e.currentTarget を使う
          const shop_camapaign_item_id = $(e.currentTarget).data('item-id');
          const target_el = $(`.destroy_flag_${shop_camapaign_item_id}`);
          // 削除フラグON
          target_el.val(1);
          $(e.currentTarget)
            .parents('.p-formSections__item')
            .removeClass('active');
        },
        // new 画面で、直前の送信内容から復元された質問(未保存)を取り除く
        // 保存済みレコードではないため destroy フラグは使わず、DOMから直接削除する
        remove_new_item: function (e) {
          if (this.staticItemsCount + this.fields.length <= 1) {
            alertify.error('質問は１つ以上必要です');
            return;
          }
          this.staticItemsCount -= 1;
          $(e.currentTarget).closest('.p-formSections__item').remove();
        },
      },
    });

    // 静的ループ側 (質問を追加で増やしていない件数) の初期値を実 DOM から算出する。
    // mount 直後は fields が空のため、この時点で .p-formSections__item に
    // 該当する要素は静的ループ側の質問のみ (質問を追加分は含まれない)
    this.vm.staticItemsCount = this.element.querySelectorAll(
      '.p-formSections__item',
    ).length;

    // 回答タイプ指定用セレクトボックスの表示を選択済みの値に合わせて初期化する
    // (new: 入力エラーで戻された質問, edit: 保存済みの質問, いずれも選択済みの値を持ちうる)
    for (const el of this.element.querySelectorAll('.item_types')) {
      // 選択されているセレクトボックスのvalueがtextareaの場合
      // TODO: 分岐条件は暫定。リリース前に要リファクタ
      if ($(el).val().match(/text/)) {
        // 行数設定のためtextareaタグを表示
        $(el)
          .closest('.p-formA__item')
          .nextAll('.text_area_option')
          .addClass('active');
        // 回答の選択肢を設定するためのinputタグを非表示
        $(el)
          .closest('.p-formA__item')
          .next('.item_options_field')
          .removeClass('active');
      } else if (
        $(el)
          .val()
          .match(/picture/)
      ) {
        // 行数設定のためtextareaタグを非表示
        $(el)
          .closest('.p-formA__item')
          .nextAll('.text_area_option')
          .removeClass('active');
        // 回答の選択肢を設定するためのinputタグを非表示
        $(el)
          .closest('.p-formA__item')
          .next('.item_options_field')
          .removeClass('active');
      } else if ($(el).val().match(/star/) || $(el).val().match(/date/)) {
        $(el)
          .closest('.p-formA__item')
          .next('.item_options_field')
          .removeClass('active');
      } else {
        $(el)
          .closest('.p-formA__item')
          .nextAll('.text_area_option')
          .removeClass('active');
        $(el)
          .closest('.p-formA__item')
          .next('.item_options_field')
          .addClass('active');
      }
    }
  }

  // メモリリーク防止のため、Vueインスタンスを破棄
  disconnect() {
    this.vm?.$destroy();
  }
}
